module.exports = "https://cdn-assessment.mathletics.com/app/124/assets/images/d94ff847a95dd381ae85a39a5b95f777.svg";